import React from "react";
import CartContainer from "../components/CartContainer";

function Cart(props) {
  return (    
      <CartContainer/>
  );
}

export default Cart;


// WEBPACK FOOTER //
// ./src/pages/Cart.jsx